import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';
import classNames from 'classnames';
import { WithLoaderWrapper } from 'ziphy-web-shared/basic/lib/loaders';
import { Title } from 'ziphy-web-shared/basic/lib/simple';
import { $layouts } from 'ziphy-web-shared/basic/utils/layouts';
import ChatComponent from '@core/src/nedoShared/features/chat/components/ChatComponent/ui/ChatComponent';
import { hasRequiredAttachments, hasUploadedAttachments, } from '@core/src/nedoShared/features/consultations/helpers/requiredAttachments';
import { OrderItemActionsDropdown } from '@core/src/nedoShared/modules/orders/OrderItem/ui/OrderItemActionsDropdown/OrderItemActionsDropdown';
import $livequeueConsultation from '@core/src/store/livequeueConsultationsStore';
import { formatConsultationDate } from '@nedoShared/modules/orders/OrderItem/lib/formatConsultationDate';
import { OrderItem } from '@nedoShared/modules/orders/OrderItem/ui/OrderItem';
import { AttachmentReminder } from '../../nedoShared/modules/orders/AttachmentReminder/AttachmentReminder';
import styles from './ClientChatPage.module.scss';
const ClientChatPage = () => {
    const [isLoading, setLoading] = useState(true);
    const { orderId, chatId } = useParams();
    const [maxChatHeight, setMaxChatHeight] = useState('');
    const headerRef = useRef(null);
    const containerRef = useRef(null);
    const updateHeight = () => {
        if (headerRef.current && containerRef.current) {
            setMaxChatHeight(containerRef.current.offsetHeight - headerRef.current.offsetHeight + 'px');
        }
        else {
            setMaxChatHeight(undefined);
        }
    };
    useEffect(() => {
        updateHeight();
        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, []);
    useEffect(() => {
        if (!isLoading) {
            updateHeight();
        }
    }, [isLoading]);
    // Keep CSS variable with layout bottom offset in sync to avoid body scroll
    useEffect(() => {
        const bottom = ($layouts.marginBottom || 0) + 'px';
        document.documentElement.style.setProperty('--layout-margin-bottom', bottom);
        if (!isLoading)
            updateHeight();
        return () => {
            document.documentElement.style.setProperty('--layout-margin-bottom', '0px');
        };
    }, [$layouts.marginBottom, isLoading]);
    useEffect(() => {
        if (orderId) {
            $livequeueConsultation.getConsultationById(orderId).then((data) => {
                setLoading(false);
            });
        }
        else {
            setLoading(false);
        }
    }, [orderId]);
    const handleMoreInfoClick = () => {
        // TODO: Implement burger click
    };
    return (_jsx(WithLoaderWrapper, Object.assign({ isLoading: isLoading, loaderMode: 'pageWrapper', className: classNames(styles.content), visibleCondition: !isLoading }, { children: _jsxs("div", Object.assign({ className: classNames(styles.content), ref: containerRef }, { children: [_jsxs("div", Object.assign({ className: styles.top, ref: headerRef }, { children: [_jsxs("div", Object.assign({ className: styles.desktopTitleWrapper }, { children: [_jsx(Title, Object.assign({ size: 'h1', className: classNames('mb-8') }, { children: `Consultation, ${formatConsultationDate($livequeueConsultation.selectedConsultation)}` })), _jsx(OrderItemActionsDropdown, { order: $livequeueConsultation.selectedConsultation })] })), _jsxs("div", Object.assign({ className: styles.orderInfo }, { children: [_jsx(OrderItem, { order: $livequeueConsultation.selectedConsultation, showButtons: false, showBackButton: true, showMoreButton: true }), hasRequiredAttachments($livequeueConsultation.selectedConsultation) &&
                                    !hasUploadedAttachments($livequeueConsultation.selectedConsultation) && (_jsx(AttachmentReminder, {}))] }))] })), _jsx("div", Object.assign({ className: classNames('container', styles.contentInner) }, { children: _jsx(ChatComponent, { chatId: chatId, consultation: $livequeueConsultation.selectedConsultation, maxHeight: maxChatHeight }) }))] })) })));
};
export default observer(ClientChatPage);
